import { CreateChurnRequestDocument, GetChurnRequestsDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Payload = {
  mainChurnReason: string
  secondaryChurnReason?: string
}

const useCreateChurnRequest = () => {
  const [createChurnRequest, { loading }] = useMutation(CreateChurnRequestDocument, {
    extractorFn: (data) => data.billingMutations.createBillingChurnRequest,
  })

  return {
    loading,
    create({ mainChurnReason, secondaryChurnReason }: Payload) {
      return createChurnRequest({
        variables: {
          mainChurnReason,
          secondaryChurnReason: secondaryChurnReason || '',
        },
        refetchQueries: [GetChurnRequestsDocument],
      })
    },
  }
}

export default useCreateChurnRequest
